import { UpdatePaymentApiLoginInfoApi } from "@/features/accounts/payment/api/services/update-login-info-api";
import { UpdatePaymentApiLoginInfoRequestModel } from "@/features/accounts/payment/api/services/update-login-info-model";

/// MoneyLook ログイン情報更新認可開始画面要求（API版）処理
export class UpdatePaymentApiLoginInfoService {
  private updatePaymentApiLoginInfoApi = new UpdatePaymentApiLoginInfoApi();

  /**
   * MoneyLook ログイン情報更新認可開始画面要求（API版）API実行
   */
  public async updatePaymentApiLoginInfo(param: UpdatePaymentApiLoginInfoRequestModel) {
    return await this.updatePaymentApiLoginInfoApi.updatePaymentApiLoginInfo(param);
  }
}
